import { render, staticRenderFns } from "./KilosEmbarcados.vue?vue&type=template&id=87d77b6e&"
import script from "./KilosEmbarcados.vue?vue&type=script&lang=js&"
export * from "./KilosEmbarcados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports